<template>
  <v-container :fluid="true">
    <networks-table />
  </v-container>
</template>

<script>
import NetworksTable from "./components/NetworksTable";
import { mapActions, mapMutations } from "vuex";
import { ADD_HEADER_SETTINGS } from "@/store/modules/layout/types";

export default {
  name: "advertisers",
  components: { NetworksTable },
  data: () => ({}),
  methods: {
    ...mapActions({
      addSettings: `layout/${ADD_HEADER_SETTINGS}`,
    }),
  },
  beforeMount() {
    this.addSettings({
      pageName: "Advertisers",
      actions: [],
    });
  },
};
</script>

<style scoped></style>
